import { apiClient } from './axios'

/**
 *
 * @param {uuid} form_id
 * @returns {
 *  form_type_id: uuid,
 *  created_by_user_id: uuid,
 *  form: json,
 *  is_done: boolean,
 *  created_at: date,
 *  updated_at: date,
 * }
 */
export const getForm = async (id, section) => {
  try {
    return (await apiClient.get(`api/form/${id}/${section}`)).data.results[0]
  } catch (err) {
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

/**
 * returns all forms of form_type
 * @param {uuid} form_type_id
 * @returns {
 *  form_type_id: uuid,
 *  created_by_user_id: uuid,
 *  form: json,
 *  is_done: boolean,
 *  created_at: date,
 *  updated_at: date,
 * }
 */
export const getForms = async (formTypeId) => {
  try {
    return await apiClient.get(`api/forms/${formTypeId}`)
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

/**
 * Post filled form here
 * @param {json} data
 * @returns
 */
export const postForm = async (data) => {
  try {
    return await apiClient.post('api/form', data)
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const getImage = async ({file, ext}) => {
  ///api/image/{filename}
  try {
    return await apiClient.get(`api/image/${file}/${ext}` , {
      responseType: 'blob',  // Ensure binary response
    })
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const getUserCompetitions = async () => {
  try {
    return (await apiClient.get(`api/user-competitions`)).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const isFillableForm = async (formId) => {
  try {
    return (await apiClient.get(`api/fillable-form/${formId}`)).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}


export const makeDone = async (competitionId) => {
  try {
    return (await apiClient.post(`api/done-form`, {competitionId})).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}


export const checkIsDone = async (competitionId) => {
  try {
    return (await apiClient.get(`api/is-form-done/${competitionId}`)).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const getAllInstitutions = async () => {
  try {
    const response = await apiClient.get('api/institutions')
    return response.data
  } catch (error) {
    console.error('Error fetching institutions:', error)
    return false
  }
}


